module.exports = __webpack_public_path__ + "static/img/personal-scan-right.8b6cea3e.jpg";